import { get } from '@/api/index'
const pre = '/dapi/b-access-layer/v1/access'

/**
 * 获取员工列表
 */
export const getDetail = (id) => {
  return get(pre + '/content-management/content/get2C?contentId=' + id)
}
